import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=cf07a66e&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"
import style0 from "./Brand.vue?vue&type=style&index=0&id=cf07a66e&prod&scoped=true&lang=css"
import style1 from "./Brand.vue?vue&type=style&index=1&id=cf07a66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf07a66e",
  null
  
)

export default component.exports